import { actionTypes } from './actions'

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.USERS_RECEIVED:
      return action.payload
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/with-users/container/reducer.js